// Valores por defecto cuando la URL no trae UTMs principales
export const UTM_DEFAULT_SOURCE = "directo";
export const UTM_DEFAULT_MEDIUM = "web";
export const UTM_DEFAULT_CAMPAIGN = "landing_web_ford";

const urlSinUtmsPrincipales = (query) =>
  !query.get("utm_source") && !query.get("utm_medium") && !query.get("utm_campaign");

// Configuración de números de WhatsApp por UTM parameters
export const whatsappConfig = {
  default: {
    number: "+543516825130",
    message: "Hola Montironi Ford!",
  },

  tiktok: {
    number: "+5493516521609",
    message: "Hola Montironi Ford! Quisiera más información sobre sus vehículos.",
    utm_source: "tiktok",
    utm_medium: "paid",
    campaigns: {
      "smart-lead": {
        number: "+5493516521609",
        message: "Hola Montironi Ford! Quisiera más información sobre sus vehículos Smart.",
      },
      lead: {
        number: "+5493516521609",
        message: "Hola Montironi Ford! Quisiera más información sobre sus vehículos.",
      },
    },
  },
};

export const getWhatsAppUrl = (utmParams = {}) => {
  const { utm_source, utm_medium, utm_campaign } = utmParams;

  if (utm_source === "tiktok" && utm_campaign) {
    const tiktokConfig = whatsappConfig.tiktok;
    const campaignConfig = tiktokConfig.campaigns[utm_campaign];

    if (campaignConfig) {
      const encodedMessage = encodeURIComponent(campaignConfig.message);
      return `https://api.whatsapp.com/send?phone=${campaignConfig.number}&text=${encodedMessage}`;
    }
  }

  if (utm_source === "tiktok") {
    const tiktokConfig = whatsappConfig.tiktok;
    const encodedMessage = encodeURIComponent(tiktokConfig.message);
    return `https://api.whatsapp.com/send?phone=${tiktokConfig.number}&text=${encodedMessage}`;
  }

  if (utm_source && whatsappConfig[utm_source]) {
    const config = whatsappConfig[utm_source];
    const encodedMessage = encodeURIComponent(config.message);
    return `https://api.whatsapp.com/send?phone=${config.number}&text=${encodedMessage}`;
  }

  const defaultConfig = whatsappConfig.default;
  const encodedMessage = encodeURIComponent(defaultConfig.message);
  return `https://api.whatsapp.com/send?phone=${defaultConfig.number}&text=${encodedMessage}`;
};

export const getUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  if (urlSinUtmsPrincipales(query)) {
    return {
      utm_source: UTM_DEFAULT_SOURCE,
      utm_medium: UTM_DEFAULT_MEDIUM,
      utm_campaign: UTM_DEFAULT_CAMPAIGN,
      utm_term: "",
    };
  }
  return {
    utm_source: query.get("utm_source") || sessionStorage.getItem("utm_source") || UTM_DEFAULT_SOURCE,
    utm_medium: query.get("utm_medium") || sessionStorage.getItem("utm_medium") || UTM_DEFAULT_MEDIUM,
    utm_campaign:
      query.get("utm_campaign") || sessionStorage.getItem("utm_campaign") || UTM_DEFAULT_CAMPAIGN,
    utm_term: query.get("utm_term") || sessionStorage.getItem("utm_term") || "",
  };
};

export const saveUtmParams = () => {
  const query = new URLSearchParams(window.location.search);
  if (!query) return;

  if (urlSinUtmsPrincipales(query)) {
    sessionStorage.setItem("utm_source", UTM_DEFAULT_SOURCE);
    sessionStorage.setItem("utm_medium", UTM_DEFAULT_MEDIUM);
    sessionStorage.setItem("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    sessionStorage.removeItem("utm_term");
    return;
  }

  if (query.get("utm_source")) {
    sessionStorage.setItem("utm_source", query.get("utm_source"));
  }
  if (query.get("utm_medium")) {
    sessionStorage.setItem("utm_medium", query.get("utm_medium"));
  }
  if (query.get("utm_campaign")) {
    sessionStorage.setItem("utm_campaign", query.get("utm_campaign"));
  }
  if (query.get("utm_term")) {
    sessionStorage.setItem("utm_term", query.get("utm_term"));
  }
};

export const getCurrentUrlWithUtmDefaults = () => {
  const currentUrl = new URL(window.location.href);
  const query = currentUrl.searchParams;

  if (urlSinUtmsPrincipales(query)) {
    query.set("utm_source", UTM_DEFAULT_SOURCE);
    query.set("utm_medium", UTM_DEFAULT_MEDIUM);
    query.set("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    return currentUrl.toString();
  }

  const src = query.get("utm_source") || sessionStorage.getItem("utm_source") || UTM_DEFAULT_SOURCE;
  const med = query.get("utm_medium") || sessionStorage.getItem("utm_medium") || UTM_DEFAULT_MEDIUM;
  const camp =
    query.get("utm_campaign") || sessionStorage.getItem("utm_campaign") || UTM_DEFAULT_CAMPAIGN;
  if (!query.get("utm_source")) query.set("utm_source", src);
  if (!query.get("utm_medium")) query.set("utm_medium", med);
  if (!query.get("utm_campaign")) query.set("utm_campaign", camp);

  return currentUrl.toString();
};

export const buildUtmQueryString = () => {
  const { utm_source, utm_medium, utm_campaign } = getUtmParams();
  return `?utm_source=${encodeURIComponent(utm_source)}&utm_medium=${encodeURIComponent(
    utm_medium
  )}&utm_campaign=${encodeURIComponent(utm_campaign)}`;
};

// Mantiene los UTMs visibles en la URL al navegar (no usa solo sessionStorage).
export const getNavigationSearch = (searchFromRouter = "") => {
  if (searchFromRouter && searchFromRouter.startsWith("?")) {
    return searchFromRouter;
  }
  if (typeof window !== "undefined" && window.location.search) {
    return window.location.search;
  }
  return buildUtmQueryString();
};

export const buildRouteWithUtms = (pathname, searchFromRouter = "") => ({
  pathname,
  search: getNavigationSearch(searchFromRouter),
});

export const WHATSAPP_CONSULTA_PHONE = "5493513527817";

export const buildWhatsAppConsultaUrl = () => {
  const urlWithUtm = getCurrentUrlWithUtmDefaults();
  const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
  const encodedMessage = encodeURIComponent(whatsappMessage);
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_CONSULTA_PHONE}&text=${encodedMessage}`;
};

export const openWhatsAppConsulta = () => {
  const whatsappUrl = buildWhatsAppConsultaUrl();
  const opened = window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  if (!opened) {
    window.location.assign(whatsappUrl);
  }
};
